import React from 'react';
import PropTypes from 'prop-types';
import { ImageCrop } from 'ui-components';
import { Link } from 'react-router-dom';
import ProfilePic from './User/ProfilePic';

export default class AuthHeaderMenuVendorNav extends React.Component {
  state = {
    uncroppedImages: [],
    croppedImage: null
  };

  imageToState = image => {
    this.setState({ uncroppedImages: [], croppedImage: image });
  };

  setProfileImage = image => {
    this.setState({ uncroppedImages: [image] });
  };

  persistProfileImage = image => {
    this.props.vendor.$setProfileImage(image, 'vendors');
  };

  newMerchant = () => {
    this.props._search.setSearchTerm('', null);
    this.props.toggleMenu();
  };

  switchVendor = vendor => {
    this.props.toggleMenu();
    this.props._customer.updateCustomerVendor({ data: [vendor] });
  };

  render() {
    const { customer, entities, vendor } = this.props;

    return (
      <div>
        <p>
          {customer.get('account').get('zip') &&
            customer.get('account').get('zip')}
          <br />
          {/* {this.props.isValidAuth(vendor) &&
          <Link className="links" to="/dashboard#account" onClick={this.props.toggleMenu}>
            Account
          </Link>
        }
        {this.props.isValidAuth(vendor) &&
          " |"
        } */}
          <button onClick={this.props._auth.logOut} className="btn-link links">
            Sign Out
          </button>
        </p>

        <hr />

        {this.props.isValidAuth(vendor) && (
          <div className="vendors">
            {entities
              .get('vendors')
              .valueSeq()
              .map((v, i) => (
                <div key={i} className="header-vendor">
                  <ProfilePic
                    {...this.props}
                    vendor={v}
                    view="link"
                    profileType="vendors"
                    className="d-inline-block mr-2"
                  >
                    <img
                      className="d-inline-block"
                      src={v.profilePicUrl(
                        'w_400,h_400,c_crop,g_face,r_max/w_30,h_30',
                        'vendors'
                      )}
                      alt="profile"
                    />
                  </ProfilePic>
                  {v.name}
                  <br />
                  <Link
                    to="/dashboard"
                    onClick={() => this.switchVendor(v)}
                    className="links"
                  >
                    Dashboard
                  </Link>{' '}
                  |{' '}
                  <Link
                    to="/dashboard#profile"
                    onClick={() => this.switchVendor(v)}
                    className="links"
                  >
                    Profile
                  </Link>{' '}
                  |{' '}
                  <ProfilePic
                    {...this.props}
                    vendor={v}
                    view="link"
                    profileType="vendors"
                    className="links d-inline-block"
                  >
                    <span>Change Profile Pic</span>
                  </ProfilePic>
                </div>
              ))}
          </div>
        )}

        <p className="pt-3">
          <Link to="/search" className="links" onClick={this.newMerchant}>
            <i className="fa fa-plus" /> Add another Merchant account
          </Link>
        </p>

        <ImageCrop
          {...this.props}
          persist={true}
          stateCallback={this.imageToState}
          persistCallback={this.persistProfileImage}
          uncroppedImages={this.state.uncroppedImages}
        />
      </div>
    );
  }
}

AuthHeaderMenuVendorNav.propTypes = {
  isValidAuth: PropTypes.func.isRequired,
  toggleMenu: PropTypes.func.isRequired,
  vendor: PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./src/components/AuthHeaderMenuVendorNav.js